
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class StorePopup extends Vue
{
    /**
     * 数据
     * @private
     * @returns string
     */
    @Prop({type: String, default: ()=>''})
    private source: string;

    /**
     * 推广弹窗跳转类型map
     * @private
     * @returns object
     */
     private jumpLinkTypeMap: any = {
        home: 101,
        personalCenter: 102,
        physical: 201,
        healthProduct: 202,
        rights: 203,
        coupon: 301
    }

    /**
     * 推广弹窗弹出位置map
     * @private
     * @returns object
     */
    private popupPositionMap: any = {
        home: 0,
        personalCenter: 1
    }

    /**
     * 推广弹窗关闭按钮位置map
     * @private
     * @returns object
     */
    private popupCloseStyleMap: any = {
        bottom: 0,
        top: 1
    }

    /**
     * 是否显示推广弹窗
     * @private
     * @returns void
     */
    private showStorePopup: boolean = false;

    /**
     * 推广弹窗信息
     * @private
     * @returns any
     */
    private get storePopupObj(): any
    {
        return this.$store.state.storePopupObj || null;
    }

    /**
     * 推广弹窗是否已显示过
     * @private
     * @returns any
     */
    private get showedStorePopup(): any
    {
        let data = {home: false, personalCenter: false};
        if (localStorage.getItem("showedStorePopup")) {
            return JSON.parse(localStorage.getItem("showedStorePopup"))
        }
        else {
            localStorage.setItem("showedStorePopup", JSON.stringify(data));
            return data;
        }
    }

    /**
     * 监听推广弹窗数据变化
     * @private
     * @returns void
     */
    @Watch("storePopupObj",{immediate: true})
    private onChangeStorePopup(newVal: any, oldVal: any): void
    {
        // 已登录，且推广弹窗在当前页面，且未显示过，才弹出
        if (localStorage.getItem("userInfo") && newVal && newVal[this.source] && newVal[this.source].popupPosition == this.popupPositionMap[this.source] && this.showStorePopup == false && this.showedStorePopup && this.showedStorePopup[this.source] == false) {
            this.showStorePopup = true;
            // 改变当前来源的弹窗状态为true，已弹出
            let sourceKey = this.source;
            let data: any = {};
            data[sourceKey] = true;
            localStorage.setItem("showedStorePopup", JSON.stringify({
                ...this.showedStorePopup,
                ...data,
            }));
        }
    }
    
    /**
     * 关闭推广弹窗
     * @private
     * @returns void
     */
    private onStorePopupClose(): void {
        this.showStorePopup = false;
    }

    /**
     * 点击推广弹窗跳转链接
     * @private
     * @returns void
     */
    private onToPage(): void {
        this.onStorePopupClose();
        // 无跳转
        if (!this.storePopupObj || !this.storePopupObj[this.source] || !this.storePopupObj[this.source].jumpLink) {
            return;
        }
        // 首页/个人中心
        if (this.storePopupObj[this.source].jumpLink.type === this.jumpLinkTypeMap[this.source]) {
            return;
        }
        // 首页
       if (this.storePopupObj[this.source].jumpLink.type === this.jumpLinkTypeMap.home) {
            this.$router.push({name: "home"});
        }
        // 个人中心
       if (this.storePopupObj[this.source].jumpLink.type === this.jumpLinkTypeMap.personalCenter) {
            this.$router.push({name: "personal-center"});
        }
        // 跳转商品，未配置商品
        if (!this.storePopupObj[this.source].jumpLink.dataList || !this.storePopupObj[this.source].jumpLink.dataList.length) {
            return;
        }
        let ids = this.storePopupObj[this.source].jumpLink.ids;
        let dataList = this.storePopupObj[this.source].jumpLink.dataList;
        switch (this.storePopupObj[this.source].jumpLink.type) {
            case this.jumpLinkTypeMap.healthProduct:
                localStorage.setItem("productList", JSON.stringify(ids));
                // 单条数据跳详情，多条数据跳列表
                if (ids.length === 1) {
                    this.onToDetail(dataList[0])
                }
                else {
                    this.$router.push({name:"health-product-list"});
                }
                break;
            case this.jumpLinkTypeMap.rights:
                localStorage.setItem("rightsList", JSON.stringify(ids));
                if (ids.length === 1) {
                    this.$router.push({name:"rights-shop-detail",query:{id: dataList[0].id}})
                }
                else {
                    this.$router.push({name:"rights-shop-list"});
                }
                break;
            case this.jumpLinkTypeMap.physical:
                localStorage.setItem("physicalPackageList", JSON.stringify(ids));
                if (ids.length === 1) {
                    this.$router.push({name: "package-detail", query:{id: dataList[0].targetId, productId: dataList[0].id}});
                }
                else {
                    this.$router.push({name:"physical-package-list"});
                }
                break;
            case this.jumpLinkTypeMap.coupon:
                this.$router.push({name:"coupon-list-info", query:{cid: dataList[0].id, from: 'home'}});
                break;
            default:
                break;
        }
    }
    /**
     * 实物商品
     * @private
     * @returns void
     */
    protected onToDetail(item: any): void
    {
        // 体检套餐 PhysicalPackage = 0
        // 医疗服务 MedicalService = 2
        // 实物 Goods = 4
        // 健管服务 HealthManageService = 6
        // 问诊购药 DiagMedicine = 2002
        // 就医绿通 Greenway = 2004
        // 齿科服务 Dental = 2006
        // 眼科服务 Eye = 2008
        // 疫苗服务 Vaccine = 2010
        // 中医服务 TCM = 2012
        // 轻医美 MedicalBeauty = 2014

        if(item.productType == 0)
        {

            // 体检套餐
            this.$router.push({name: "package-detail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 4)
        {
            // 实物套餐
            this.$router.push({name: "goodsDetail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 8)
        {
            // 健康险产品
            this.$router.push({name: "healthInsuranceDetail", query:{id: item.targetId}});
        }
        else
        {
            this.$router.push({name:"medical", query:{id:item.targetId, productId: item.id}});
        }
    }
}
